import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTimes } from "react-icons/fa";
import { API_URL } from "../constants";
import { UserTypes } from "../constants";

const MachineAgencyAddress = ({ address, agenceId, token, agence }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [editMode, setEditMode] = useState(false);
  const [adresseSuggestions, setAdresseSuggestions] = useState([]);
  const [adresseQuery, setAdresseQuery] = useState(address);
  const [suggestionActivated, setSuggestionActivated] = useState(false);
  const userType = user.type;

  const fetchAdresseSuggestions = async (query) => {
    try {
      const response = await axios.get(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(query)}`);
      setAdresseSuggestions(response.data.features);
    } catch (error) {
      console.log("Erreur suggestions adresse :", error.message);
    }
  };

  useEffect(() => {
    if (adresseQuery.trim() !== "" && editMode && !suggestionActivated) {
      fetchAdresseSuggestions(adresseQuery);
    } else {
      setAdresseSuggestions([]);
    }
  }, [adresseQuery, editMode, suggestionActivated]);

  const handleSaveClick = async () => {
    try {
      const response = await axios.patch(
        `${API_URL}/agences/${agenceId}`,
        { adresse: adresseQuery },
        { headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) { setEditMode(false); window.location.reload(); }
    } catch (error) {
      console.error("Erreur mise à jour adresse", error);
    }
  };

  return (
    <div>
      {editMode ? (
        <div className="flex flex-col gap-2">
          <div className="relative">
            <input
              type="text"
              value={adresseQuery}
              onChange={(e) => { setAdresseQuery(e.target.value); setSuggestionActivated(false); }}
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-white pr-8 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
              placeholder="Adresse"
            />
            {adresseQuery && (
              <FaTimes
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer hover:text-gray-600"
                onClick={() => setAdresseQuery("")}
              />
            )}
          </div>

          {adresseSuggestions.length > 0 && !suggestionActivated && (
            <div className="border border-gray-100 rounded-xl overflow-hidden shadow-sm">
              {adresseSuggestions.map((s) => (
                <div
                  key={s.properties.id}
                  onClick={() => { setAdresseQuery(s.properties.label); setSuggestionActivated(true); setAdresseSuggestions([]); }}
                  className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-50 border-b border-gray-50 last:border-0 transition"
                >
                  {s.properties.label}
                </div>
              ))}
            </div>
          )}

          <div className="flex gap-2">
            <button onClick={handleSaveClick} className="px-4 py-2 bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold rounded-xl transition">
              Valider
            </button>
            <button onClick={() => { setEditMode(false); setAdresseQuery(address); }} className="px-4 py-2 bg-red-500 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition">
              Annuler
            </button>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Adresse</span>
          <span className="text-sm text-gray-700">{agence.adresse || <span className="italic text-gray-400">Non renseignée</span>}</span>
          {(userType === UserTypes.SUPER || userType === UserTypes.ADMIN) && (
            <FaEdit className="cursor-pointer text-gray-400 hover:text-loginBordure transition shrink-0" onClick={() => setEditMode(true)} />
          )}
        </div>
      )}
    </div>
  );
};

export default MachineAgencyAddress;